// src/components/Footer.js
import styled from '@emotion/styled';

const FooterContainer = styled.footer`
  background-color: ${props => props.theme.colors.primary};
  color: white;
  padding: 2rem;
  text-align: center;
  width: 100%;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <p>© 2024 Zoe Technologies. All rights reserved.</p>
    </FooterContainer>
  );
};

export default Footer;
